import { render, staticRenderFns } from "./mAboutUs.vue?vue&type=template&id=5def1f37&scoped=true&"
import script from "./mAboutUs.vue?vue&type=script&lang=js&"
export * from "./mAboutUs.vue?vue&type=script&lang=js&"
import style0 from "./mAboutUs.vue?vue&type=style&index=0&id=5def1f37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5def1f37",
  null
  
)

export default component.exports